import { useDispatch} from "react-redux";
import { IconButton, Typography } from "@mui/material";
import ContainedIconButton from "../../common/buttons/ContainedIconButton";
import { setSavedAlbumsCurrentPage } from "../../../actions/albumListActions";
import { useAlbumListPagerConfig } from "../../../hooks/savedAlbums/useAlbumListPagerConfig";
import { PAGER_BUTTON_SIZE, PAGER_HEIGHT } from "../../../utils/constants/viewConstants";
import { useViewport } from "../../../hooks/others/useViewport";

const AlbumListPager = () => {    
    const PreviousPageButton = () => {
        return <PageButton pageIndex={currentPage - 1} text="<" />
    }

    const NextPageButton = () => {
        return <PageButton pageIndex={currentPage + 1} text=">" />
    }
    
    const PageButton = ({pageIndex, text, current}) => {
        const dispatch = useDispatch();
        const ButtonType = current ? ContainedIconButton : IconButton;

        const onClick = () => {
            if(pageIndex === undefined) return;

            dispatch(setSavedAlbumsCurrentPage(pageIndex));
        }

        return (
            <ButtonType style={{width: pagerButtonSize, height: pagerButtonSize}} onClick={onClick}>
                <Typography>{text}</Typography>
            </ButtonType>
        )
    }

    const { currentPage, pagerButtonsInfo, disabled } = useAlbumListPagerConfig();
    const pagerButtonSize = useViewport(PAGER_BUTTON_SIZE);

    return (
        <div className="d-flex flex-row jc-center ai-center gap-1" style={{ height: PAGER_HEIGHT }}>
            {
                !disabled &&
                <>
                {
                    pagerButtonsInfo && 
                    pagerButtonsInfo.length > 1 && 
                    <>
                        <PreviousPageButton />
                        {
                            pagerButtonsInfo.map((info, i) => (
                                <PageButton key={i} 
                                    pageIndex={info.index} 
                                    text={info.text}
                                    current={info.current}
                                />
                            ))
                        }
                        <NextPageButton />
                    </>
                }
                </>
            }
        </div>
    )
}

export default AlbumListPager;